import {ViewStyle} from 'react-native';

import Gender from '../../value_objects/Gender';
import NameLabelColor from '../NameLabelColor';

export default class CharacterResourceOptions {
  constructor(
    public containerStyle?: ViewStyle,
    public wideCharacterStyle?: ViewStyle,
    public faceCenterPosition?: {top: number; left: number},
    public gender?: Gender,
    public transparent?: boolean,
    public nameLabelColor?: NameLabelColor,
    public inverted?: boolean,
  ) {}
}
